import PropTypes from "prop-types";
import Radio from "app/pages/.shared/form/Radio";
import PromotionCodeContainer from "app/pages/Booking/PromotionCode/PromotionCodeContainer";
import { FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";
import { PAYMENT_COUPON_TYPE } from "app/constants";
import "./PromotionCodeRadio.scss";

const PromotionCodeRadio = ({
	field,
	onChange,
	onValidPromoCodeApplied,
	value,
	onPromoCodeFocus,
}) => {
	return (
		<Radio
			field={field}
			showIcon={true}
			name="promo-code-radio"
			id="promo-code-radio"
			value={PAYMENT_COUPON_TYPE.PROMOCODE}
			body={
				<div className="promotion-code-radio__body">
					<PromotionCodeContainer
						submit={false}
						onValidPromoCodeApplied={onValidPromoCodeApplied}
						onFocus={onPromoCodeFocus}
					/>
				</div>
			}
			checked={field.value === PAYMENT_COUPON_TYPE.PROMOCODE}
			toggle={() => {
				onChange(PAYMENT_COUPON_TYPE.PROMOCODE);
			}}
			data-testid={`coupon-promocode-input`}
		>
			<div className="promotion-code-radio__content">
				<div className="promotion-code-radio__name">
					<FormattedMessage id="payment.coupons.input.promocode.label" />
				</div>
				<div className="promotion-code-radio__amount">
					{value > 0 && (
						<AmountContainer amount={value} prefix={<AmountSign sign="-" />} />
					)}
				</div>
			</div>
		</Radio>
	);
};

PromotionCodeRadio.propTypes = {
	field: PropTypes.object,
	value: PropTypes.number,
	onChange: PropTypes.func,
	onValidPromoCodeApplied: PropTypes.func,
	onPromoCodeFocus: PropTypes.func,
};

PromotionCodeRadio.defaultProps = {
	field: {},
	onChange: () => {},
	onPromoCodeFocus: () => {},
};

export default PromotionCodeRadio;
